import React from 'react';

function ScrollDepth({ data }) {
  if (data.length === 0) {
    return (
      <div className="empty-state">
        <div className="icon">📜</div>
        <h3>スクロールデータがありません</h3>
        <p>ユーザーがページをスクロールするとデータが表示されます</p>
      </div>
    );
  }

  // Build scroll depth distribution in 10% increments
  const buckets = Array(11).fill(0); // 0%, 10%, 20%, ... 100%

  data.forEach(entry => {
    const maxDepth = entry.maxScrollDepth || 0;
    // Everyone who reached X% also reached all percentages below X%
    for (let i = 0; i <= 10; i++) {
      if (maxDepth >= i * 10) {
        buckets[i]++;
      }
    }
  });

  const maxCount = Math.max(...buckets, 1);

  const getColor = (percent) => {
    if (percent >= 80) return '#3fb950';
    if (percent >= 60) return '#58a6ff';
    if (percent >= 40) return '#bc8cff';
    if (percent >= 20) return '#f0883e';
    return '#f85149';
  };

  return (
    <div>
      <h3 style={{ marginBottom: 16, fontSize: 16, color: '#e1e4e8' }}>
        スクロール到達率（{data.length}セッション）
      </h3>
      <div className="scroll-chart">
        <div className="scroll-bar-container">
          {buckets.map((count, i) => {
            const percent = i * 10;
            const height = (count / maxCount) * 100;
            const reachRate = data.length > 0 ? Math.round((count / data.length) * 100) : 0;
            return (
              <div
                key={i}
                className="scroll-bar"
                style={{
                  height: `${Math.max(height, 2)}%`,
                  background: `linear-gradient(to top, ${getColor(percent)}, ${getColor(percent)}88)`,
                }}
              >
                <div className="tooltip">
                  {percent}% 到達: {count}人 ({reachRate}%)
                </div>
              </div>
            );
          })}
        </div>
        <div className="scroll-labels">
          {buckets.map((_, i) => (
            <span key={i}>{i * 10}%</span>
          ))}
        </div>
      </div>

      {/* Detailed stats */}
      <div style={{ marginTop: 24, display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: 8 }}>
        {[25, 50, 75, 100].map(threshold => {
          const reached = data.filter(d => (d.maxScrollDepth || 0) >= threshold).length;
          const rate = data.length > 0 ? Math.round((reached / data.length) * 100) : 0;
          return (
            <div key={threshold} style={{
              padding: 12,
              background: '#0d1117',
              borderRadius: 8,
              border: '1px solid #2d333b',
              textAlign: 'center',
            }}>
              <div style={{ fontSize: 24, fontWeight: 700, color: getColor(threshold) }}>{rate}%</div>
              <div style={{ fontSize: 12, color: '#8b949e' }}>{threshold}%到達率</div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default ScrollDepth;
